import { useTranslation } from "@opendash/core";
import { useUIPermission } from "@opendash/plugin-parse";
import { Tabs, TabsProps } from "antd";
import { observer } from "mobx-react-lite";
import React, { useEffect } from "react";
import {
  RecentMessage,
  TicketDescription,
  TicketEventsTimeline,
  TicketImageCarousel,
  TicketManager,
} from "../..";
import { OpenService } from "../../../../types/config";
import { TicketTodoList } from "../../messages/components/TicketTodoList";
import { useTicketUpdate } from "../hooks/useTicketUpdate";

type Props = {
  ticketManager: TicketManager;
};

/**
 * @description Displays a page with detailed information about a single ticket.
 * @param id Needs the objectId of the ticket in navigation (/ticket/{objectId})
 */
export const TicketDetailWrapper = observer((props: Props) => {
  const t = useTranslation();
  const canCreateMessage = useUIPermission([
    OpenService.Permissions.Create.message,
  ]);
  const {} = useTicketUpdate({ saveHash: true });

  useEffect(() => {
    props.ticketManager.fetchTickets();
  }, []);

  const tabs: TabsProps["items"] = [
    {
      key: "messages",
      label: t("maintenance:ticket.recentmessage.headline"),
      children: (
        <RecentMessage
          showdivider={false}
          hideForm={!canCreateMessage}
          reload={() => props.ticketManager.fetchTickets()}
        />
      ),
    },
    {
      key: "images",
      label: t("maintenance:administration.ticket.create.form.media.title"),
      children: <TicketImageCarousel />,
    },
    {
      key: "todos",
      label: t("maintenance:ticket.todos.label"),
      children: (
        <TicketTodoList reload={() => props.ticketManager.fetchTickets()} />
      ),
    },
    {
      key: "history",
      label: t("maintenance:ticket.eventtimeline.headline"),
      children: <TicketEventsTimeline showdivider={false} />,
    },
  ];
  return (
    <>
      <TicketDescription
        onOkUpdate={() => {
          props.ticketManager.fetchTickets();
        }}
      />
      <Tabs
        defaultActiveKey="messages"
        items={tabs}
        style={{ background: "#fff", padding: "16px", marginTop: "16px" }}
      />
    </>
  );
});
